/* eslint-disable react/prop-types */
import React from 'react'
import ErrorMessage from 'utils/ErrorMessage'
import Flex from 'components/Flex'
import DeleteIcon from 'components/icons/Delete'
import PDFIcon from 'components/icons/PDFIcon'
import JPGIcon from 'components/icons/JPGIcon'
import { deleteFile } from 'modules/Drive/actions'
import { useDispatch } from 'react-redux'
import moment from 'moment'
import SuccessMessage from 'utils/SuccessMessage'
import {
  StyledCardDiv,
  StyledImg,
  StyledH2,
  StyledP,
  StyledDelete,
  AdjustIcon,
  SmallCirlcle,
  SpanText,
  VisibleDiv,
} from 'components/Uploader/Styles'
import Visibility from 'components/icons/Visibility'

const FileReaderVisible = ({ file, setFile, setIsUpdateButtonEnabled, showDelete = true }) => {
  const dispatch = useDispatch()
  let size = (file.size / 1024 / 1024).toFixed(2) + ' MB'

  const handleRemove = async () => {
    let response = await dispatch(deleteFile(file?.url))
    if (response) {
      setFile(null)
      if (setIsUpdateButtonEnabled) {
        setIsUpdateButtonEnabled(false)
      }
      return SuccessMessage('File deleted successfully!')
    } else {
      return ErrorMessage('Failed to delete the file!')
    }
  }

  const viewFile = () => {
    const newWindow = window.open(file?.url, '_blank', 'noopener,noreferrer')
    if (newWindow) newWindow.opener = null
  }
  
  return (
    <StyledCardDiv spaceBetween center alignCenter>
      <StyledImg>
        <AdjustIcon margin>
          {file?.type === 'pdf' ? <PDFIcon /> : <JPGIcon />}
        </AdjustIcon>
        <Flex column>
          <StyledH2>{file?.name}</StyledH2>
          <StyledP alignCenter>
            <SpanText>
              {moment(file?.date)?.format('Do MMM, YYYY') +
                ' at ' +
                moment(file?.date)?.format('h:mm')}
            </SpanText>
            <SmallCirlcle />
            <SpanText>{size}</SpanText>
          </StyledP>
        </Flex>
      </StyledImg>

      <Flex alignCenter>
        {showDelete && (
          <StyledDelete onClick={() => handleRemove()}>
            <DeleteIcon />
          </StyledDelete>
        )}
        <VisibleDiv onClick={() => viewFile()}>
          <Visibility />
        </VisibleDiv>
      </Flex>
    </StyledCardDiv>
  )
}

export default FileReaderVisible
